import React, { useState, useRef } from "react";
import moment from "moment";
import Navbar from "../../components/Navbar/Navbar";
import { useNavigate } from "react-router-dom";
import { Table, Typography } from "antd";
import { UsePostRequest } from "../../utils/api/ApiRequests";
import {
  getIsAdminLogin,
  getEmployeeId,
} from "../../utils/Common";
import * as XLSX from "xlsx"

const { Title } = Typography;
export default function PerformanceEvalutaion() {
  const componentRef = useRef();
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  // const branchOptions = GetAllBranches();
  // const businessUnitOptions = GetAllBusinessUnits();
  const dateFormat = "YYYY-MM-DD";
  const isAdminLogin = getIsAdminLogin();
  const employeeId = getEmployeeId();
  const [searchTerm, setSearchTerm] = useState("");

  const [filterConfig, setFilterConfig] = useState({
    is_updated: false,
    employee_id: isAdminLogin?null:employeeId,
    date_from: moment().format(dateFormat),
    date_to: moment().format(dateFormat),
  });

  const tableColumns = [
    {
      title: "Employee",
      dataIndex: "employee_name",
      key: "employee_name",
    },
    {
      title: "Absent (days)",
      dataIndex: "absent_count",
      key: "absent_count",
    },
    {
      title: "Present (days)",
      dataIndex: "present_count",
      key: "present_count",
    },
    {
      title: "Regular OT (hrs)",
      dataIndex: "regular_ot_hr",
      key: "regular_ot_hr",
      render: (data) => <div>{data}</div>,
    },
    {
      title: "Restday OT (hrs)",
      dataIndex: "restday_ot_hr",
      key: "restday_ot_hr",
      render: (data) => <div>{data}</div>,
    },
    {
      title: "Late (hrs)",
      dataIndex: "late",
      key: "late",
      render: (data) => <div>{data}</div>,
    },
    {
      title: "Undertime (hrs)",
      dataIndex: "undertime_hr",
      key: "undertime_hr",
      render: (data) => <div>{data}</div>,
    },
    {
      title: "Communication Letter",
      dataIndex: "communication_count",
      key: "communication_count",
      render: (data) => <div>{data}</div>,
    },
  ];

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      setFilterConfig((prev) => ({ ...prev, term: searchTerm }));
    }
  };

  const handleDateFilter = (e) => {
    if (e) {
      setFilterConfig((prev) => ({
        ...prev,
        date_from: e[0].format(dateFormat),
        date_to: e[1].format(dateFormat),
      }));
    }
  };

  // const handleFilter = (e, field) => {
  //   setFilterConfig((prev) => ({ ...prev, [field]: e }));
  // };

  const handleRowClick = (rowData) => {
    const passValues = {
      id: rowData.employee_id,
      fullname: rowData.employee_name,
      date_from: filterConfig.date_from,
      date_to: filterConfig.date_to,
    };
    navigate("/employees/history-report", { state: passValues });
  };

  const rowProps = (record) => ({
    onClick: () => handleRowClick(record),
  });

  function exportToExcel () {
    const excelData = [tableColumns.map((col) => col.title)]; // insert header titles first
    // populate excel data
    tableData.forEach((data) => {
      let tempArray = tableColumns.map((col) => data[col.key])
      excelData.push(tempArray)
    })
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(excelData);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    const excelBlob = new Blob([XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })], { type: 'application/octet-stream' });
    const excelUrl = URL.createObjectURL(excelBlob);
    const downloadAnchor = document.createElement('a');
    downloadAnchor.href = excelUrl;
    downloadAnchor.download = 'Performance Evaluation.xlsx';
    downloadAnchor.click();
    setTimeout(() => {
      URL.revokeObjectURL(excelUrl);
    }, 100);
}

  React.useEffect(() => {
    async function fetchTableData() {
      setIsFetching(true);
      setTableData([]);
      const response = await UsePostRequest(
        "timesheets/performance_evaluation",
        filterConfig
      );
      if (response.data) {
        setTableData(response.data);
      }
      setIsFetching(false);
    }

    fetchTableData();
  }, [filterConfig]);

  return (
    <Navbar
    activeNav="performanceevaluation"
      pageTitle="Performance Evaluation Report"
      noButton
      // withPrintBtn
      // printContent={componentRef}
      withDateRangePicker
      onDateChange={handleDateFilter}
      setSearchQuery={(e) => setSearchTerm(e)}
      onSearch={handleSearch}
      searchPlaceholder="employee"
      isManager
      searchable={isAdminLogin}
      pageDownloadButtonTitle="Download Excel" 
      isDownloadBtn
      onClickDownloadButton = {exportToExcel}
    >
    
      <Table
        className="mt-4"
        rowKey="id"
        onRow={(record) => ({
          ...rowProps(record),
          style: { cursor: "pointer" },
        })}
        columns={tableColumns}
        dataSource={tableData}
        loading={isFetching}
      />

      <div className="printOnly">
        <div className="print-report-page" ref={componentRef}>
          <Title level={5} className="px-4">
            PERFORMANCE EVALUATION
          </Title>
          <Table
            className="px-2 mt-3"
            rowKey="id"
            columns={tableColumns}
            dataSource={tableData}
            pagination={false}
          />
        </div>
      </div>
    </Navbar>
  );
}
